import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useDeepLinkContext } from "../../hooks";
import {
  DocumentViewItem,
  EmptyList,
  ViewContainer,
} from ".";

const useStyles = makeStyles(theme => ({
  spacing: {
    "& > .MuiGrid-item": {
      padding: 5,
    },
  },
  masonry: {
    "& .react-image-masonry-col": {
      [theme.breakpoints.down("sm")]: {
        width: "33.333% !important",
      },
    },
  },
}));

const DocumentView = ({ products }) => {
  const classes = useStyles();

  const deepLinkContext = useDeepLinkContext();
  const { deepLink } = deepLinkContext;

  const [linkedProductId] = useState(deepLink?.resourceId);

  useEffect(() => {
    if (deepLink && products && products.items && products.items.length > 0) {
      deepLinkContext.clearData();
    }
  }, [deepLink, products]);

  const RenderItems = ({ items }) => (
    items.map(product =>
    (
      <DocumentViewItem
        key={product.id}
        product={product}
        showProductModalOnOpen={product.id == linkedProductId}
      />
    ))
  );

  const RenderView = ({ items }) => {
    const haveItems = Array.isArray(items) && items.length > 0;

    return (
      <ViewContainer>
        <Grid container className={classes.spacing}>
          {haveItems && <RenderItems items={items} />}
          {!haveItems && <EmptyList messageId="product.categoryEmpty" />}
        </Grid>
      </ViewContainer>
    );
  };

  return (
    !deepLink && products && products.items && (
      <RenderView items={products.items} />
    )
  );
};

DocumentView.propTypes = {
  products: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        thumbnailImageUri: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default DocumentView;
